import React from 'react';

function ContentRow({ id, className, children }) {
  return (
    <div id={id || ''} className={`row no-gutters justify-content-start py-2 py-md-5 ${className || ''}`}>
      {children}
    </div>
  );
}

export default ContentRow;